define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    function default_1(category, action, label, value, nonInteractive) {
        if ((typeof gtag) !== 'undefined') {
            gtag('event', action, { event_category: category, event_label: label, non_interaction: nonInteractive, value: value });
        }
        if ((typeof _gaq) !== 'undefined') {
            _gaq.push(['_trackEvent', category, action, label, value, nonInteractive]);
        }
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/analytics.js
// module id = 3
// module chunks = 0